var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (socialData) {pug_html = pug_html + "\u003Cdiv class=\"share__content\"\u003E\u003Cul class=\"share__list\"\u003E";
// iterate socialData.list
;(function(){
  var $$obj = socialData.list;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"share__item\"\u003E\u003Ca" + (pug.attr("class", pug.classes([socialData.setClassName(item.name)], [true]), false, true)+pug.attr("href", item.url, true, true)+" target=\"_blank\"") + "\u003E\u003Ci class=\"share__icon\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"share__count\"\u003E+\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli class=\"share__item\"\u003E\u003Ca" + (pug.attr("class", pug.classes([socialData.setClassName(item.name)], [true]), false, true)+pug.attr("href", item.url, true, true)+" target=\"_blank\"") + "\u003E\u003Ci class=\"share__icon\"\u003E\u003C\u002Fi\u003E\u003Cspan class=\"share__count\"\u003E+\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";}.call(this,"socialData" in locals_for_with?locals_for_with.socialData:typeof socialData!=="undefined"?socialData:undefined));;return pug_html;};
module.exports = template;